// extracted by mini-css-extract-plugin
export default {"contactList":"ZveV1fkOM45f0VZi96hu","contact-item-chosen-check":"o5sp0gZlCAhbGujncfWn"};